import React, { useState, useEffect, Link } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { update_api_response, update_amount_orders, update_images_data, update_comments_orders, update_blob_data, update_price_orders, update_users_view_max } from '../../../order/orders/actions.js';
import { alert_error, alert_success } from '../../../AppContext';
import axios from 'axios';
import Orders_method from './orders_method';
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import Language_i18 from '../../../js/useNationalLanguage.jsx';

function Orders_options({ input_url_orders, set_input_url_orders, services_math_1, services_math_3, isDisabled }) {
    const { i18n, lang } = Language_i18();
    const translations = {
        vi: {
            recipient_account_name: "Tên tài khoản Hust Media người nhận",
            enter_account_name: "Nhập tên tài khoản",
            amount_to_send: "Số lượng gửi",
            enter_coin_amount: "Nhập số coin",
            transfer_content: "Nội dung chuyển",
            optional_content: "Có thể bỏ trống",
            time: "Thời gian",
            send_image: "Gửi ảnh",
            image_to_convert: "Ảnh cần chuyển đổi:",
            view_sample: "Xem mẫu",
            before_after_conversion: "Trước và sau khi chuyển:",
            ai_core_note: "Lõi AI tự xây dựng không có chức năng bên khác",
            characters_to_convert: "Số ký tự chuyển đổi :",
            min_label: "Tối thiểu",
            max_label: "Tối đa"
        },
        en: {
            recipient_account_name: "Recipient Hust Media account name",
            enter_account_name: "Enter account name",
            amount_to_send: "Amount to send",
            enter_coin_amount: "Enter coin amount",
            transfer_content: "Transfer content",
            optional_content: "Can be left blank",
            time: "Time",
            send_image: "Send image",
            image_to_convert: "Image to convert:",
            view_sample: "View sample",
            before_after_conversion: "Before and after conversion:",
            ai_core_note: "Custom AI core with no external features",
            characters_to_convert: "Characters to convert:",
            min_label: "Minimum",
            max_label: "Maximum"
        }
    };
    const [show_example, setshow_example] = useState(false);
    const { slug_2 } = useParams();
    const [audioDuration, setaudioDuration] = useState(false);
    const navigate = useNavigate();
    const api_response = useSelector(state => state.api_response);
    const services_orders = useSelector(state => state.services_orders);
    const amount_orders = useSelector(state => state.amount_orders);
    const images_data = useSelector(state => state.images_data);
    const comments_orders = useSelector(state => state.comments_orders);
    const price_orders = useSelector(state => state.price_orders);
    const users_view_max = useSelector(state => state.users_view_max);
    const blob_data = useSelector(state => state.blob_data);
    const shop_insurance = useSelector(state => state.shop_insurance);

    const set_images_data = (value) => {
        dispatch(update_images_data(value));
    };
    const set_comments_orders = (value) => {
        dispatch(update_comments_orders(value));
    };
    const [Text, setText] = useState('');
    const dispatch = useDispatch();
    const set_blob_data = (value) => {
        dispatch(update_blob_data(value));
    };
    const set_api_response = (value) => {
        dispatch(update_api_response(value));
    };
    const set_amount_orders = (value) => {
        dispatch(update_amount_orders(value));
    };

    const set_price_orders = (value) => {
        dispatch(update_price_orders(value));
    };
    const set_users_view_max = (value) => {
        dispatch(update_users_view_max(value));
    };

    const handleTextChange = (e) => {
        const inputText = e.target.value;
        const updatedText = inputText.replace(/\n/g, '. ');
        set_input_url_orders(updatedText);
        setText(inputText);
    };
    useEffect(() => {
        // Đếm số ký tự trong biến text
        let characterCount = Text.length;
        characterCount = Math.round(characterCount);
        set_amount_orders(Text.length);
        services_math_1(Text.length);
    }, [Text]);
    useEffect(() => {
        set_api_response('');
    }, []);
    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > services_orders.maxorder) {
            alert_error('Bạn chỉ có thể tải tối đa ' + services_orders.maxorder + ' ảnh.');
            return;
        }
        else {
            set_amount_orders(files.length);
            services_math_1(files.length);
            set_input_url_orders(slug_2);
            const newImages = [];

            files.forEach((file, index) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    newImages.push({
                        id: index + 1, // Reset the id to start from 1 each time
                        img: reader.result,
                    });

                    // Update state with new images
                    if (newImages.length === files.length) {
                        console.log(newImages);
                        set_images_data(newImages);
                    }
                };
                reader.readAsDataURL(file);
            });
        }
    };
    // State cho ảnh khuôn mặt (chỉ tối đa 1 ảnh)
    const [faceImages, setFaceImages] = useState([]);
    const [bodyImages, setBodyImages] = useState([]);
    // Handler cho ảnh khuôn mặt (max = 1)
    const change_face = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 1) {
            alert_error('Bạn chỉ có thể tải tối đa 1 ảnh.');
            return;
        }
        const newImages = [];
        files.forEach((file, idx) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                newImages.push({ id: idx + 1, img: reader.result });
                if (newImages.length === files.length) {
                    setFaceImages(newImages);
                    process_images_data(newImages, 'face');
                    console.log('=== Face Images ===', newImages);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    // Handler cho ảnh body (max = 1)
    const change_body = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 1) {
            alert_error('Bạn chỉ có thể tải tối đa 1 ảnh.');
            return;
        }
        const newImages = [];
        files.forEach((file, idx) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                newImages.push({ id: idx + 1, img: reader.result });
                if (newImages.length === files.length) {
                    setBodyImages(newImages);
                    process_images_data(newImages, 'body');
                    console.log('=== Body Images ===', newImages);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const process_images_data = (newGroup, type) => {
        set_amount_orders(1);
        services_math_1(1);
        set_input_url_orders(slug_2);
        const faceGroup = type === 'face' ? newGroup : faceImages;
        const bodyGroup = type === 'body' ? newGroup : bodyImages;

        const faceObj = faceGroup[0]
            ? { id: 1, img: faceGroup[0].img }
            : null;
        const bodyObj = bodyGroup[0]
            ? { id: 2, img: bodyGroup[0].img }
            : null;

        const combined = [faceObj, bodyObj].filter(Boolean);
        set_images_data(combined);
        console.log('=== images_data sau process ===', combined);
    };

    const [file, setFile] = useState(null);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.type === 'application/pdf') {
            setFile(selectedFile);
            // Create FormData to append the selected PDF
            const formData = new FormData();
            formData.append('file', selectedFile); // The key 'file' should match what the backend expects

            // Axios POST request
            axios.post('https://hust.media/jop/google/pdf_text/pdf_text.php', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(response => {
                console.log('Response:', response.data);
                if (response.data) { setText(response.data); };
                set_input_url_orders(response.data);
            })
                .catch(error => {
                    alert_error(error)
                })
            // Handle the response from the server

        } else if (selectedFile && selectedFile.type.startsWith('audio/')) {
            const formData = new FormData();
            formData.append('audioFile', selectedFile); // Thêm file vào formData với key là 'audioFile'
            // selectedFile chính là Blob data của file
            const blobData = selectedFile;
            // console.log('Blob URL:', blobUrl);
            // // Bạn có thể thao tác với blobData như với bất kỳ Blob nào khác
            // console.log('Blob Data:', blobData);
            set_blob_data(blobData);
        } else {
            alert_error("Vui lòng tải đúng thể loại tệp.");
        }
    };
    const [inputType, setInputType] = useState(''); // Quản lý loại đầu vào (text hoặc pdf)
    useEffect(() => {
        if (services_orders.typeapi) {
            setInputType(services_orders.typeapi);
        }
        if (services_orders?.type && services_orders?.category?.includes("un_block_users")) {
            set_amount_orders('1');
            set_input_url_orders('un_block_users');
            services_math_1('1');
        }
        if (services_orders?.type && services_orders?.category?.includes("videos_maker")) {
            set_amount_orders('1');
            services_math_1('1');
        }
        if (services_orders?.typeapi?.includes("p2p_mmo")) {
            set_input_url_orders('p2p_mmo');
            set_amount_orders(0);
            set_price_orders(0);
            set_users_view_max(1000);
            if (services_math_3) {
                services_math_3(0, 0);
            }
        }
        if (services_orders?.typeapi?.includes("hust_search")) {
            set_amount_orders(1);
            services_math_1(1);
        }
    }, [services_orders]);
    useEffect(() => {
        if (!services_orders?.typeapi?.includes("p2p_mmo")) {
            return;
        }
        if (services_math_3) {
            services_math_3(amount_orders, price_orders);
        }
    }, [price_orders]);
    const handleRadioChange = (e) => {
        // Lấy toàn bộ đối tượng option từ dataset
        const info = JSON.parse(e.target.dataset.option);
        console.log(info); // Sẽ log toàn bộ đối tượng { label, value }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                window.location.href = info.redirect;
            }, 50);
        }
        setInputType(info.value);
        setText('');  // Đặt lại giá trị văn bản khi chuyển đổi
        setFile(null); // Đặt lại file khi chuyển đổi
        if (services_orders.category.includes("speech_text")) {
            set_input_url_orders(e.target.value);
        }
    };
    // Sử dụng useEffect khi blob thay đổi
    useEffect(() => {
        if (blob_data) {
            // Ví dụ: đọc nội dung blob dưới dạng URL (blob URL)
            const blobUrl = URL.createObjectURL(blob_data);
            // Create a URL for the selected audio file
            // Create an audio element to calculate the duration
            const audio = new Audio();
            audio.src = blobUrl;

            // Once the audio metadata is loaded, get the duration
            audio.addEventListener('loadedmetadata', () => {
                let ok_time = audio.duration; // Duration in seconds
                ok_time = Math.floor(ok_time + 1);
                console.log("Số giây âm thanh: ", ok_time);
                if (inputType == 'voice_ai') {
                } else {
                    set_amount_orders(ok_time);
                    services_math_1(ok_time);
                }
                setaudioDuration(ok_time);
                // Optional: clean up the object URL
                URL.revokeObjectURL(blobUrl);
            });
            // Chuyển đổi blob sang base64 và sau đó log ra json
            blobToBase64(blob_data).then(base64Audio => {
                const jsonData = {
                    voice_data: base64Audio // Đưa base64 vào JSON
                };
                set_comments_orders(jsonData);
                // console.log(JSON.stringify(jsonData)); // Log ra JSON trong format đẹp
            }).catch(error => {
                console.error('Error converting blob_data to base64:', error);
            });
        }
    }, [blob_data]);
    function blobToBase64(blob_data) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob_data); // Đọc blob và chuyển thành base64
        });
    };
    const textarea_ai_changes = (e) => {
        set_input_url_orders('translate');
        const inputText = e.target.value;        // Lấy giá trị từ textarea
        const charCount = inputText.length;      // Tính số ký tự
        set_amount_orders(charCount);            // Cập nhật số ký tự vào amount_orders
        set_comments_orders(inputText);               // Cập nhật giá trị commentsok
        services_math_1(charCount);
    };

    const [selected, set_selected] = useState('');

    // Đổi tên hàm xử lý chọn gói nạp
    const recharge_change_1 = (e) => {
        const value = e.target.value;
        set_selected(value);
        set_amount_orders(value);
        services_math_1(value);
    };

    const recharge_change_2 = (e) => {
        services_math_1(1);
        set_amount_orders(1);
        const value = e.target.value;
        set_selected(value);
        set_input_url_orders({
            ...input_url_orders,
            accounts_type: value
        });
    };
    const recharge_change_3 = (e) => {
        const value = e.target.value;
        const shop_insurance_new = value - shop_insurance;
        services_math_1(shop_insurance_new);
        set_amount_orders(shop_insurance_new);
    };
    return (
        <>
            {services_orders && services_orders.type && services_orders.category.includes("speech_text") && (
                <div className="p-1">
                    <>
                        <Orders_method inputType={inputType} handleRadioChange={handleRadioChange}
                            handleFileChange={handleFileChange} handleTextChange={handleTextChange}
                            Text={Text} services_orders={services_orders}
                            audioDuration={audioDuration} setaudioDuration={setaudioDuration} />
                        <div className="text-xs mt-[-1px]">
                            {translations[lang]?.min_label} {services_orders.minorder} &emsp; {translations[lang]?.max_label} {services_orders.maxorder}
                        </div>
                    </>
                </div>
            )}
            {(services_orders && services_orders.type && services_orders.category.includes("translate")) && (
                <>
                    <div className="p-1">
                        <div className="mt-0 my-0 block font-medium text-sm mx-auto">
                            Nhập văn bản cần dịch : {amount_orders}
                        </div>
                        <textarea
                            className="w-full h-40 border mb-0 border-gray-300 rounded p-2 resize-none"
                            placeholder="Nhập văn bản..."
                            value={comments_orders}
                            onChange={textarea_ai_changes}
                        />
                        <div className="text-xs mt-[-1px]">
                            {translations[lang]?.min_label} {services_orders.minorder} &emsp; {translations[lang]?.max_label} {services_orders.maxorder}
                        </div>
                    </div>
                </>
            )}
            {services_orders && services_orders.type && services_orders.category.includes("text_speech") && (
                <div className="p-1">
                    <div className="mt-0 my-0 block font-medium text-xs mx-auto">
                        {translations[lang]?.ai_core_note}
                    </div>
                    <div className="mt-0 my-0 block font-medium text-sm mx-auto">
                        {translations[lang]?.characters_to_convert} {amount_orders}
                    </div>
                    {/* Lựa chọn giữa nhập văn bản hoặc tải lên PDF với radio button */}
                    <Orders_method inputType={inputType} handleRadioChange={handleRadioChange}
                        handleFileChange={handleFileChange} handleTextChange={handleTextChange}
                        Text={Text} services_orders={services_orders}
                        audioDuration={audioDuration} setaudioDuration={setaudioDuration} />
                    {/* Hiển thị input file nếu người dùng chọn "Tải lên file PDF" */}

                    <div className="text-xs mt-[-1px]">
                        {translations[lang]?.min_label} {services_orders.minorder} &emsp; {translations[lang]?.max_label} {services_orders.maxorder}
                    </div>

                </div>
            )}

            {(services_orders && services_orders.type && services_orders.category.includes("hust_chat")) && (
                <>
                    <div className="p-1">
                        <div className="mt-0 my-0 block font-medium text-sm mx-auto">
                            Nhập câu hỏi để giải đáp : {amount_orders}
                        </div>
                        <textarea
                            className="w-full h-40 border mb-0 border-gray-300 rounded p-2 resize-none"
                            placeholder="Nhập câu hỏi..."
                            value={comments_orders}
                            onChange={textarea_ai_changes}
                        />
                        <div className="text-xs mt-[-1px]">
                            {translations[lang]?.min_label} {services_orders.minorder} &emsp; {translations[lang]?.max_label} {services_orders.maxorder}
                        </div>
                    </div>
                </>
            )}

            {(services_orders && services_orders.type && services_orders.category.includes("accounts_services")) && (
                <>
                    <label className="text-sm">Tên sản phẩm	</label>
                    <div className="input-group flex-nowrap mb-1">
                        <span className="input-group-text" id="addon-wrapping">
                            🏬
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Acc Tiktok trên 1k follow"
                            aria-label="shop_caption"
                            onChange={(e) => {
                                services_math_1(1);
                                set_amount_orders(1);
                                set_input_url_orders({
                                    ...input_url_orders,
                                    accounts_caption: e.target.value,
                                });
                            }}
                            value={input_url_orders?.accounts_caption || ""}
                        />
                    </div>

                    <label className="text-sm">Mô tả sản phẩm</label>
                    <div className="input-group flex-nowrap mb-1">
                        <span className="input-group-text" id="addon-wrapping">
                            📝
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="vd: Acc uy tín, chất lượng"
                            aria-label="shop_description"
                            onChange={(e) => {
                                services_math_1(1);
                                set_amount_orders(1);
                                set_input_url_orders({
                                    ...input_url_orders,
                                    accounts_description: e.target.value,
                                });
                            }}
                            value={input_url_orders?.accounts_description || ""}
                        />
                    </div>

                    <label className="text-sm">Hình thức bán</label>
                    <div className="mb-3 space-y-2">
                        <label className={`flex items-center p-2 border rounded cursor-pointer transition ${selected === 'local' ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'}`}>
                            <input
                                type="radio"
                                name="recharge"
                                value={'local'}
                                checked={selected === 'local'}
                                onChange={recharge_change_2}
                                className="form-radio h-4 w-4 text-blue-600"
                            />
                            <span className="ml-2 text-gray-700">Thủ công qua Hust</span>
                        </label>

                        <label className={`flex items-center p-2 border rounded cursor-pointer transition ${selected === 'api' ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'}`}>
                            <input
                                type="radio"
                                name="recharge"
                                value={'api'}
                                checked={selected === 'api'}
                                onChange={recharge_change_2}
                                className="form-radio h-4 w-4 text-blue-600"
                            />
                            <span className="ml-2 text-gray-700">Tự động qua Api</span>
                        </label>
                    </div>
                </>
            )}

            {(services_orders && services_orders.type && services_orders.category.includes("accounts_shop_profile_edit")) && (
                <>
                    <label className="text-sm">Tiền bảo hiểm</label>
                    <br />
                    <div className="input-group flex-nowrap">
                        <span className="input-group-text" id="addon-wrapping">
                            🪙
                        </span>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Tiền càng cao càng hiện đầu danh sách"
                            aria-label="amount_orders"
                            value={input_url_orders?.shop_insurance || ""}
                            name="amount_orders"
                            aria-describedby="addon-wrapping"
                            onChange={(e) => {
                                recharge_change_3(e);
                                set_input_url_orders({
                                    ...input_url_orders,
                                    shop_insurance: e.target.value,
                                });
                            }}
                        />
                    </div>
                    <div className="text-xs mt-[-1px]">
                        {translations[lang]?.min_label} {services_orders.minorder} &emsp; {translations[lang]?.max_label} {services_orders.maxorder}
                    </div>
                    <label className="text-sm">Nhập tên shop của bạn</label>
                    <div className="input-group flex-nowrap mb-1">
                        <span className="input-group-text" id="addon-wrapping">
                            🏬
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="vd: Nga Bán acc"
                            aria-label="shop_caption"
                            onChange={(e) => {
                                set_input_url_orders({
                                    ...input_url_orders,
                                    shop_caption: e.target.value,
                                });
                            }}
                            value={input_url_orders?.shop_caption || ""}
                        />
                    </div>

                    <label className="text-sm">Mô tả shop của bạn</label>
                    <div className="input-group flex-nowrap mb-3">
                        <span className="input-group-text" id="addon-wrapping">
                            📝
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="vd: Shop bán acc Hust Media uy tín, chất lượng"
                            aria-label="shop_description"
                            onChange={(e) => {
                                set_input_url_orders({
                                    ...input_url_orders,
                                    shop_description: e.target.value,
                                });
                            }}
                            value={input_url_orders?.shop_description || ""}
                        />
                    </div>
                </>
            )}
            {(services_orders && services_orders.type && services_orders.category.includes("accounts_shop_api_edit")) && (
                <>
                    <label className="text-sm">Sửa liên kết api</label>
                    <br />
                    <div className="input-group flex-nowrap mb-1">
                        <span className="input-group-text" id="addon-wrapping">
                            📝
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="vd: https://hust.media/api/v3"
                            aria-label="shop_caption"
                            onChange={(e) => {
                                set_input_url_orders({
                                    ...input_url_orders,
                                    accounts_api_url: e.target.value
                                });
                                services_math_1(1);
                                set_amount_orders(1);
                            }}
                            value={input_url_orders?.accounts_api_url || ""}
                        />
                    </div>
                    <div className="text-xs mt-[-1px]">
                        {translations[lang]?.min_label} {services_orders.minorder} &emsp; {translations[lang]?.max_label} {services_orders.maxorder}
                    </div>
                </>
            )}
            {(services_orders && services_orders.type && services_orders.category.includes("phone_recharge")) && (
                <>
                    <label className="text-sm">Chọn gói nạp</label>
                    <div className="mb-2 space-y-2">
                        <label className={`flex items-center p-2 border rounded cursor-pointer transition ${selected === '20000' ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'}`}>
                            <input
                                type="radio"
                                name="recharge"
                                value={20000}
                                checked={selected === '20000'}
                                onChange={recharge_change_1}
                                className="form-radio h-4 w-4 text-blue-600"
                            />
                            <span className="ml-2 text-gray-700">Gói nạp 20k</span>
                        </label>

                        <label className={`flex items-center p-2 border rounded cursor-pointer transition ${selected === '50000' ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'}`}>
                            <input
                                type="radio"
                                name="recharge"
                                value={50000}
                                checked={selected === '50000'}
                                onChange={recharge_change_1}
                                className="form-radio h-4 w-4 text-blue-600"
                            />
                            <span className="ml-2 text-gray-700">Gói nạp 50k</span>
                        </label>
                    </div>

                    <label className="text-sm">Nhập số điện thoại</label>
                    <br />
                    <div className="mb-2 input-group flex-nowrap">
                        <span className="input-group-text" id="addon-wrapping">
                            Sdt
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Số điện thoại nạp khuyến mãi vd: 09123..."
                            aria-label="input_url_orders"
                            value={comments_orders}
                            name="comments_orders"
                            aria-describedby="addon-wrapping"
                            onChange={(e) => {
                                set_comments_orders(e.target.value);
                                set_input_url_orders("phone_recharge");
                            }}
                        />
                    </div>
                </>
            )}

            {(services_orders && services_orders.type && services_orders.category.includes("transfer_coins")) && (
                <>
                    <label className="text-base">{translations[lang]?.recipient_account_name}</label>
                    <br />
                    <div className="input-group flex-nowrap">
                        <span className="input-group-text" id="addon-wrapping">
                            🧑
                        </span>
                        <input
                            onChange={(e) => set_input_url_orders(e.target.value)}
                            value={input_url_orders}
                            type="text"
                            className="form-control"
                            placeholder={translations[lang]?.enter_account_name}
                            aria-label="inputcaption"
                            name="inputcaption"
                            aria-describedby="addon-wrapping"
                        ></input>
                    </div>

                    <div className="p-1">
                        <label className="text-base">{translations[lang]?.amount_to_send}</label>
                        <br />
                        <div className="input-group flex-nowrap">
                            <span className="input-group-text" id="addon-wrapping">
                                🪙
                            </span>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={translations[lang]?.enter_coin_amount}
                                aria-label="amount_orders"
                                value={amount_orders}
                                name="amount_orders"
                                aria-describedby="addon-wrapping"
                                onChange={(e) => {
                                    set_amount_orders(e.target.value);
                                    services_math_1(e.target.value);
                                }}
                            />
                        </div>
                        <div className="text-xs mt-[-1px]">
                            {translations[lang]?.min_label} {services_orders.minorder} &emsp; {translations[lang]?.max_label} {services_orders.maxorder}
                        </div>
                    </div>
                    <label className="text-base">{translations[lang]?.transfer_content}</label>
                    <br />
                    <div className="input-group flex-nowrap">
                        <span className="input-group-text" id="addon-wrapping">
                            💬
                        </span>
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder={translations[lang]?.optional_content}
                            aria-label="input_url_orders"
                            value={comments_orders}
                            name="comments_orders"
                            aria-describedby="addon-wrapping"
                            onChange={(e) => set_comments_orders(e.target.value)}
                        />
                    </div>

                </>
            )}

            {(services_orders && services_orders.type && services_orders.typeapi.includes("p2p_mmo")) && (
                <>
                    <div className="p-1">
                        <label className="text-sm font-semibold">Mô tả nhiệm vụ</label>
                        <textarea
                            className="w-full h-28 border mb-0 border-gray-300 rounded p-2 resize-none"
                            placeholder="Nhập mô tả cho nhiệm vụ quay màn hình"
                            value={comments_orders}
                            onChange={(e) => set_comments_orders(e.target.value)}
                        />
                        <label className="text-sm font-semibold">Số lượng cần làm</label>
                        <div className="input-group flex-nowrap mb-1">
                            <span className="input-group-text" id="addon-wrapping">
                                🎬
                            </span>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Nhập số lượng"
                                aria-label="amount_orders"
                                value={amount_orders}
                                name="video_count"
                                aria-describedby="addon-wrapping"
                                onChange={(e) => {
                                    const newCount = e.target.value;
                                    set_amount_orders(newCount);
                                    if (services_math_3) {
                                        services_math_3(newCount, price_orders);
                                    }
                                }}
                            />
                        </div>
                        <div className="text-xs text-gray-500">
                            {translations[lang]?.min_label} {services_orders.minorder} &emsp; {translations[lang]?.max_label} {services_orders.maxorder}
                        </div>
                        <label className="text-sm font-semibold">Giá cho mỗi nhiễm vụ</label>
                        <div className="input-group flex-nowrap mb-1">
                            <span className="input-group-text" id="addon-wrapping">
                                💰
                            </span>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Nhập số lượng"
                                aria-label="amount_orders"
                                value={price_orders}
                                name="price_per_video"
                                aria-describedby="addon-wrapping"
                                onChange={(e) => {
                                    const rawPrice = e.target.value;
                                    set_price_orders(rawPrice);
                                    if (services_math_3) {
                                        services_math_3(amount_orders, Number(rawPrice || 0));
                                    }
                                }}
                            />
                        </div>
                        <div className="text-xs text-gray-500">
                            {translations[lang]?.min_label} {services_orders.servicecode.min_price_orders} &emsp; {translations[lang]?.max_label} {services_orders.servicecode.max_price_orders}
                        </div>
                        <label className="text-base">Url đến nhiệm vụ (Nếu có)</label>
                        <br />
                        <div className="input-group flex-nowrap">
                            <span className="input-group-text" id="addon-wrapping">
                                🔗
                            </span>
                            <input
                                onChange={(e) => set_input_url_orders(e.target.value)}
                                value={input_url_orders}
                                type="text"
                                className="form-control"
                                placeholder={translations[lang]?.enter_account_name}
                                aria-label="inputcaption"
                                name="inputcaption"
                                aria-describedby="addon-wrapping"
                            ></input>
                        </div>
                        <label className="text-sm font-semibold">View users tối đa</label>
                        <div className="input-group flex-nowrap mb-1">
                            <span className="input-group-text" id="addon-wrapping">
                                👁️
                            </span>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Nhập số lượng"
                                aria-label="users_view_max"
                                value={users_view_max}
                                name="users_view_max"
                                min={1}
                                max={1000}
                                aria-describedby="addon-wrapping"
                                onChange={(e) => {
                                    const rawValue = e.target.value;
                                    if (rawValue === '') {
                                        set_users_view_max('');
                                        return;
                                    }
                                    const parsedValue = Number(rawValue);
                                    if (Number.isNaN(parsedValue)) {
                                        return;
                                    }
                                    const nextValue = Math.max(1, Math.min(1000, parsedValue));
                                    set_users_view_max(nextValue);
                                }}
                            />
                        </div>
                    </div>
                </>
            )}
            {(services_orders && services_orders.type && services_orders.typeapi?.includes("hust_search")) && (
                <>
                    <label className="text-sm">Điền từ khóa cần tìm kiếm</label>
                    <br />
                    <div className="mb-2 input-group flex-nowrap">
                        <span className="input-group-text" id="addon-wrapping">
                            keyword
                        </span>
                        <input
                            onChange={(e) => {
                                set_input_url_orders(e.target.value);
                                services_math_1(1);
                                set_amount_orders(1);
                            }}
                            value={input_url_orders}
                            type="text"
                            className="form-control mb-0"
                            placeholder="Nhập đúng sản phẩm cần tìm"
                            aria-label="inputcaption"
                            name="inputcaption"
                            aria-describedby="addon-wrapping"
                            disabled={isDisabled}
                        ></input>
                    </div>
                </>
            )}


            {(services_orders && services_orders.type && services_orders.category.includes("review_app")) && (
                <>
                    <label className="text-sm">Tên tk ng nhận</label>
                    <br />
                    <div className="mb-2 input-group flex-nowrap">
                        <span className="input-group-text" id="addon-wrapping">
                            tk
                        </span>
                        <input
                            onChange={(e) => {
                                set_input_url_orders(e.target.value);
                                services_math_1(1);
                                set_amount_orders(1);
                            }}

                            value={input_url_orders}
                            type="text"
                            className="form-control mb-0"
                            placeholder="vd: users123"
                            aria-label="inputcaption"
                            name="inputcaption"
                            aria-describedby="addon-wrapping"
                        ></input>
                    </div>

                </>
            )
            }
            {
                (services_orders && services_orders.type && services_orders.category.includes("savings_checking")) && (
                    <>
                        <label className="text-sm">Money</label>
                        <br />
                        <div className="input-group flex-nowrap">
                            <span className="input-group-text" id="addon-wrapping">
                                🪙
                            </span>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Money"
                                aria-label="amount_orders"
                                value={amount_orders}
                                name="amount_orders"
                                aria-describedby="addon-wrapping"
                                onChange={(e) => {
                                    set_amount_orders(e.target.value);
                                    services_math_1(e.target.value);
                                }}
                            />
                        </div>
                        <label className="text-sm">Time</label>
                        <br />
                        <div className="mb-2 input-group flex-nowrap">
                            <span className="input-group-text" id="addon-wrapping">
                                🕒
                            </span>
                            <input
                                onChange={(e) => set_input_url_orders(e.target.value)}
                                value={input_url_orders}
                                type="number"
                                className="form-control mb-0"
                                placeholder="Time"
                                aria-label="inputcaption"
                                name="inputcaption"
                                aria-describedby="addon-wrapping"
                            ></input>
                        </div>

                    </>
                )
            }
            {
                (services_orders && services_orders.type && services_orders.category.includes("videos_maker")) && (
                    <>
                        <label className="text-base">Link videos của bạn</label>
                        <br />
                        <div className="mb-2 input-group flex-nowrap">
                            <span className="input-group-text" id="addon-wrapping">
                                url
                            </span>
                            <input
                                onChange={(e) => {
                                    set_input_url_orders(e.target.value);
                                    services_math_1(1);
                                    set_amount_orders(1);
                                }}
                                value={input_url_orders}
                                type="text"
                                className="form-control mb-0"
                                placeholder="Copy và điền liên kết ở đây"
                                aria-label="inputcaption"
                                name="inputcaption"
                                aria-describedby="addon-wrapping"
                                disabled={isDisabled}  // Điều kiện disable
                            ></input>
                        </div>

                    </>
                )
            }

            {
                (services_orders && services_orders.type && services_orders.category.includes("scams_check")) && (
                    <>
                        <label className="text-base">Nhập sdt hoặc số tài khoản</label>
                        <br />
                        <div className="mb-2 input-group flex-nowrap">
                            <span className="input-group-text" id="addon-wrapping">
                                search
                            </span>
                            <input
                                onChange={(e) => {
                                    set_input_url_orders(e.target.value);
                                    services_math_1(1);
                                    set_amount_orders(1);
                                }}
                                value={input_url_orders}
                                type="text"
                                className="form-control mb-0"
                                placeholder="Điền từ khóa"
                                aria-label="inputcaption"
                                name="inputcaption"
                                aria-describedby="addon-wrapping"
                                disabled={isDisabled}  // Điều kiện disable
                            ></input>
                        </div>

                    </>
                )
            }

            {
                (services_orders && services_orders.type && services_orders.category.includes("auto_tools")) && (
                    <>
                        <div className="p-1">
                            <label className="text-base">Nhập số ngày thuê tools</label>
                            <br />
                            <div className="input-group flex-nowrap">
                                <span className="input-group-text" id="addon-wrapping">
                                    🕔
                                </span>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Date"
                                    aria-label="amount_orders"
                                    value={amount_orders}
                                    name="amount_orders"
                                    aria-describedby="addon-wrapping"
                                    onChange={(e) => {
                                        set_amount_orders(e.target.value);
                                        services_math_1(e.target.value);
                                        set_input_url_orders(services_orders.category);
                                    }}
                                />
                            </div>
                            <div className="text-xs mt-[-1px]">
                                {translations[lang]?.min_label} {services_orders.minorder} &emsp; {translations[lang]?.max_label} {services_orders.maxorder}
                            </div>
                        </div>
                    </>
                )
            }
            {
                (services_orders && services_orders.type && services_orders.category.includes("savings_orders")) && (
                    <>
                        <label className="text-sm">Money</label>
                        <br />
                        <div className="input-group flex-nowrap">
                            <span className="input-group-text" id="addon-wrapping">
                                🪙
                            </span>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Money"
                                aria-label="amount_orders"
                                value={amount_orders}
                                name="amount_orders"
                                aria-describedby="addon-wrapping"
                                onChange={(e) => {
                                    set_amount_orders(e.target.value);
                                    services_math_1(e.target.value);
                                    set_input_url_orders(services_orders.category);
                                }}
                            />
                        </div>
                    </>
                )
            }
            {
                services_orders && services_orders.type && (services_orders.category.includes("image_text") || services_orders.category.includes("image_vip") || services_orders.category.includes("image_face")) && (
                    <>
                        {
                            services_orders.typeapi.includes("faceswap") ?
                                (<>
                                    <div className="p-1">
                                        <div className="text-base mb-0">Ảnh khuôn mặt</div>
                                        <div className="text-center">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={change_face}
                                                className="rounded"
                                            />
                                            <div className="flex justify-center mt-0">
                                                {faceImages.map((image) => (
                                                    <img
                                                        key={image.id}
                                                        src={image.img}
                                                        alt={`Face ${image.id}`}
                                                        className="mx-2 w-44 rounded"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="p-1">
                                        <div className="text-base mb-0">Ảnh bị thay</div>
                                        <div>
                                            <div className="text-center">
                                                Ảnh cần chuyển đổi:
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={change_body}
                                                    multiple="multiple"
                                                    className="rounded"
                                                />
                                                <div className="flex justify-center mt-0">
                                                    {bodyImages.map((image) => (
                                                        <img
                                                            key={image.id}
                                                            src={image.img}
                                                            alt={`Face ${image.id}`}
                                                            className="mx-2 w-44 rounded"
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>) :
                                (<>
                                    <div className="p-1">
                                        <div className="text-base mb-0">{translations[lang]?.send_image}</div>
                                        <div>
                                            <div className="text-center">
                                                {translations[lang]?.image_to_convert}                                            <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                    multiple="multiple"
                                                    className="rounded"
                                                />
                                                <div className="flex justify-center mt-0">
                                                    {images_data.map((image) => (
                                                        <img key={image.id} src={image.img} alt={`Selected ${image.id}`} className="mx-2 w-44 rounded" />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>)
                        }

                        {
                            (services_orders.category.includes("image_vip") || services_orders.category.includes("image_face")) &&
                            (<>
                                <div className="mb-1">
                                    <div className="text-center">
                                        <div
                                            className="button inline-block px-2 py-1 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition duration-300"
                                            onClick={() => setshow_example(!show_example)}
                                        >
                                            {translations[lang]?.view_sample}
                                        </div>
                                        {show_example && (
                                            <div className="flex justify-center mx-3">
                                                <div className="w-full max-w-[400px] text-center">
                                                    {translations[lang]?.before_after_conversion}
                                                    <img
                                                        src={
                                                            services_orders.typeapi.includes("faceswap")
                                                                ? "https://hust.media/jop/google/image_vip/faceswap.webp"
                                                                : services_orders.category.includes("image_vip")
                                                                    ? "https://hust.media/jop/google/image_vip/demo.png"
                                                                    : services_orders.category.includes("image_face")
                                                                        ? "https://hust.media/jop/google/image_vip/face_demo.png"
                                                                        : ""  // hoặc 1 URL default nếu muốn
                                                        }
                                                        alt="Selected"
                                                        className="w-full rounded mt-2"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                            )
                        }
                    </>
                )
            }
        </>
    );
}

export default Orders_options;
